import { CheckCircle2, PanelsTopLeft } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { Partner } from "@/context/PartnerContext";
import type { PartnerMiniPageMissingField } from "@/api/adminPartners";

const MISSING_LABELS: Record<PartnerMiniPageMissingField, string> = {
  image: "εικόνα",
  description: "περιγραφή",
  phone: "τηλέφωνο",
  location: "τοποθεσία",
  services: "υπηρεσίες",
};

interface PartnerMiniPageStatusProps {
  partner: Partner;
  compact?: boolean;
}

export function PartnerMiniPageStatus({ partner, compact = false }: PartnerMiniPageStatusProps) {
  const missing = partner.miniPageMissing || [];
  const complete = partner.miniPageComplete === true && missing.length === 0;

  if (complete) {
    return (
      <Badge variant="outline" className="border-emerald-200 bg-emerald-50 text-emerald-800">
        <CheckCircle2 className="mr-1 h-3 w-3" />
        {compact ? "Πλήρης" : "Mini page πλήρης"}
      </Badge>
    );
  }

  const details = missing.map((field) => MISSING_LABELS[field]).join(" + ");
  return (
    <Badge
      variant="outline"
      className="max-w-full border-amber-200 bg-amber-50 text-amber-900"
      title={details ? `Λείπει: ${details}` : "Η mini page χρειάζεται έλεγχο"}
    >
      <PanelsTopLeft className="mr-1 h-3 w-3 shrink-0" />
      <span className="truncate">
        {compact ? (details || "Έλεγχος") : `Mini page · ${details || "έλεγχος"}`}
      </span>
    </Badge>
  );
}
